<script>
import Base from './base.vue';
import { ZOOM_MEETING_PRO_MIN_LICENSE, planTypes, BILLING_CYCLE } from '@/common/constants';
import { mapGetters } from 'vuex';
import { computedCallingPlans, computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import { getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { plansof } from '@/utils/chain';
import { editBasePlanWithPartnerMixin } from "@/views/config/partner-refer/mixin/edit-plan-with-partner";
import promoModifyMixin from '@/common/mixin/promo-modify-mixin';
import _ from "lodash";
import { bundleRegions, zoneBundleMode } from '../helper';
import { PBX_REGIONS } from '../../ZOOM_PHONE/helper/constants';

export default {
  name: 'Upgrade',
  extends: Base,
  mixins: [editBasePlanWithPartnerMixin, promoModifyMixin],
  computed: {
    ...mapGetters(['boughtPlans', 'hasZoomDevice']),
    monthlyPlanDisabled() {
      const disabledBillingCycleList = this.eligibleInfoForPromoCase?.disabledBillingCycleList;
      return _.includes(disabledBillingCycleList, BILLING_CYCLE.MONTHLY);
    },
    annualPlanDisabled() {
      const disabledBillingCycleList = this.eligibleInfoForPromoCase?.disabledBillingCycleList;
      return _.includes(disabledBillingCycleList, BILLING_CYCLE.ANNUAL);
    },
    monthlyDisabledAlertMessage() {
      return this.getCycleDisabledReasonForPartnerWithBasePlanUpgrade()?.reason;
    },
    minCallingPlan() {
      return this.minHostAndReason.min;
    },
    maxCallingPlan() {
      return 9999;
    },
    showAddAnotherRegionCTA() {
      return false;
    },
    currentEditBizPlus() {
      return this.getSelectedPlans.find(p => p.type === planTypes.ZOOM_ONE_BUNDLE);
    },
    minHostAndReason() {
      const boughtMeetingPlanLicense = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0)?.cartInfo?.selected_number ?? 0;
      const boughtPropPlanLicense = plansof(this.boughtPlans).type(planTypes.ZONE_PRO_PLUS).get(0)?.cartInfo?.selected_number ?? 0;
      const min =  Math.max(boughtMeetingPlanLicense, boughtPropPlanLicense, ZOOM_MEETING_PRO_MIN_LICENSE);
      return {
        reason: '',
        min
      }
    },
    licenseTips() {
      return this.minHostAndReason.reason;
    },
    showCycle() {
      // if has purchased zp base plan, return false
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? false;
      if (basePlan) {
        return false;
      }
      return true;
    },
    planBillInfo() {
      if (this.showCycle) return false;
      const plan = computedCallingPlans(this.boughtPlans)?.[0] ?? {};
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? {};
      const payment = getZPCallingFeesText(basePlan).title;
      const billingCycle = basePlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO ? BILLING_CYCLE.MONTHLY : plan.billing_cycle;
      return {
        billing_cycle: billingCycle,
        payment
      }
    },
    planDetailLabel() {
      // from pricing page upgrade CTA
      if (this.$context.is.prop2bundle || this.$context.is.pro2bundle || this.$context.is.biz2bundle) return false;
      return this.$t('billing.zone.explore_other_plans_edit');
    },
    pbxRegions() {
      if (this.hasZoomDevice) {
        return bundleRegions.filter((x) => x.key === PBX_REGIONS.US_AND_CANADA);
      }
      return bundleRegions.filter((x) => {
        if (x.key === PBX_REGIONS.JP) return this.$config('enableBizPlusJapanOnlineBuy');
        if (this.$config('hideZoomPhoneUKIRPlans')) return x.key !== PBX_REGIONS.UK_AND_IRELAND;
        return true;
      })
      .filter((p) => this.mx_filterPbxRegionItem(p))
      .filter(x => this.bundlePlans.find(item => item.region === x.key))
      .filter(zoneBundleMode.filter);
    },
  },
  methods: {
    mx_filterPbxRegionItem(item) {
      const region = this.eligibleInfoForPromoCase?.targetPromoPlan?.region;
      return region ? item?.key === region : true;
    },
    async handlePlanDetailsClick() {
      await this.showFullComparisonDialog();
    },
  }
}
</script>
